<template>

    <Modal :hideFooter="true"
           :title="title"
           ref="sendMessageToCustomerModal">
        <template v-slot:body>



            <div v-for="contact in localContacts">

                <img :src="$handlers.customerHandler.getContactImage(contact)"
                    @error="$handlers.customerHandler.onContactImageError($event, contact)"
                     style="border-radius:100%;width:60px;height:60px;border:solid 1px #eeeeee;margin-left:13px;">


                {{ contact.firstName }} {{ contact.lastName }}

                <br>



                <div class="row"
                     style="padding-right:73px;">


                    <div class="col-6">
                        <div class="mb-3">
                            <label class="form-label"
                                   style="user-select: none;cursor:pointer"
                                   @click="contact.sendEmail = !contact.sendEmail">


                                <span style="position:relative;top:1px;"
                                      class="planup-checkbox planup-checkbox-purple"
                                      :class="{ checked: contact.sendEmail }">
                                    <i class="fa fa-check"></i>
                                </span>


                                מייל

                            </label>
                            <input class="form-control"
                                   v-model="contact.email">
                        </div>
                    </div>


                    <div class="col-6">
                        <div class="mb-3">
                            <label class="form-label"
                                   style="user-select: none;cursor:pointer"
                                   @click="contact.sendWhatsap = !contact.sendWhatsap">


                                <span style="position:relative;top:1px;"
                                      class="planup-checkbox planup-checkbox-purple"
                                      :class="{ checked: contact.sendWhatsap }">
                                    <i class="fa fa-check"></i>
                                </span>


                                ואצאפ

                            </label>
                            <input class="form-control"
                                   type="tel"
                                   v-model="contact.phone">
                        </div>
                    </div>



                </div>





            </div>

            <div class="mb-3">

                <label class="form-label">
                    הודעה אישית


                    <span style="color:#ab8ce4;cursor:pointer" @click="$refs.messageTemplatePopup.show()">
                        בחירה מתוך תבניות
                    </span>
                </label>

                <textarea class="form-control"
                          v-model="message"
                          style="height:100px;"></textarea>


                <MessageTemplatePopup @text="message = $event" ref="messageTemplatePopup"></MessageTemplatePopup>


            </div>

            <div class="mb-3"
                 v-if="link">

                <label class="form-label">
                    לינק מצורף
                </label>

                <br>


                <div style="word-break: break-all;text-align: left;direction:ltr">
                    {{ link }}

                </div>




            </div>


            <div class="pull-right">

                <button class="btn btn-primary"
                        @click="send">
                    שלח
                </button>


            </div>


        </template>
    </Modal>
</template>

<script>
import MessageTemplatePopup from '../MessageTemplates/MessageTemplatePopup.vue';
import TemplateFieldsHandler from '../../modules/TemplateFieldsHandler';




export default {
    name: 'SendMessageToCustomerModal',
    props: {
        customerId: {
            required: true
        },
        contacts: {
            required: true
        },
        link: {
            required: false
        },
        title: {
            required: false,
            default: 'שליחה ללקוח'
        },

        //event context for {{parameter}} resolution in message templates (optional)
        event: {
            required: false,
            default: null
        },

        //the message the modal opens with (the menu's approval link: a ready text)
        defaultMessage: {
            required: false,
            default: ''
        },

        //the email's wording: the document's name when the title is a caption, a link to sign that is not
        //a /sign/ link (the menu's approval link), and the button's text
        docName: {
            required: false,
            default: ''
        },
        signRequest: {
            type: Boolean,
            default: false
        },
        ctaText: {
            required: false,
            default: ''
        },

        //whatsapp only for a contact with a phone (mail ticked only when there is no phone) - a request
        //meant for whatsapp (בקשת מילוי פרטי לקוח); by default both are ticked when filled
        whatsappFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {


        let localContacts = deepCopy(this.contacts);
        localContacts.forEach(contact => {
            contact.sendEmail = !!contact.email && !(this.whatsappFirst && contact.phone);
            contact.sendWhatsap = !!contact.phone;
        });

        return {
            localContacts,
            message: this.defaultMessage || ''
        };
    },
    methods: {
        send() {

            let whatsappNumbers = [];
            let emails = [];

            this.localContacts.forEach(contact => {
                if (contact.sendEmail) {
                    emails.push(contact.email);
                }

                if (contact.sendWhatsap) {
                    whatsappNumbers.push(contact.phone);
                }
            });

            // WhatsApp selected but the account is disconnected: don't hard-block anymore —
            // failed sends land in the queue (settings > ואצאפ) and can be flushed after reconnect
            if (whatsappNumbers.length > 0 &&
                (this.$store.state.businessSettings.whatsappServer || this.$store.state.businessSettings.whatsappEverConnected) &&
                !this.$store.state.whatsappStatus.includes('0')) {
                this.$swal({
                    title: 'חשבון הואצאפ מנותק',
                    html: 'הודעות הואצאפ לא יישלחו כרגע - הן יישמרו בתור ההודעות שבהגדרות הואצאפ,<br>ואפשר יהיה לשלוח אותן אחרי חיבור מחדש. להמשיך?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'שמור בתור',
                    cancelButtonText: 'ביטול',
                }).then(() => {
                    this.reallySend(whatsappNumbers, emails, true);
                }).catch(() => { });
                return;
            }

            this.reallySend(whatsappNumbers, emails, false);
        },

        reallySend(whatsappNumbers, emails, whatsappGoesToQueue) {

            //a message about a meeting ({{תאריך הפגישה}}, {{קישור לאישור הפגישה}}...) speaks of the
            //customer's next meeting, as in the chat - this modal has no meeting of its own, and the
            //tokens used to go out empty
            let meetingLookup = TemplateFieldsHandler.usesMeetingFields(this.message) && this.customerId
                ? TemplateFieldsHandler.nextMeetingOfCustomer(this.customerId)
                : Promise.resolve(null);

            meetingLookup.then(meeting => this.sendWithMeeting(whatsappNumbers, emails, whatsappGoesToQueue, meeting));
        },

        sendWithMeeting(whatsappNumbers, emails, whatsappGoesToQueue, meeting) {

            //{{parameter}} values are resolved here on the client and sent as a
            //{hebrew field name: value} map; the per-recipient {{שם איש הקשר}} is filled
            //on the server (CustomersService.fillTemplateFields) from the contacts list.
            //built with or without an event - the customer/general/booking tokens
            //(e.g. {{קישור לזימון פגישה}}) resolve from the contacts alone
            let eventFieldValues = TemplateFieldsHandler.buildFieldMappings(meeting || null, this.event, { contacts: this.localContacts });

            let contactsForTemplate = this.localContacts.map(contact => ({
                //the id is what lets the server hand this recipient a personalised booking link
                id: contact.id,
                name: this.$handlers.customerHandler.getDisplayName(contact),
                //{{שם פרטי של איש הקשר}} / {{שם משפחה של איש הקשר}} of this recipient
                firstName: contact.firstName || '',
                lastName: contact.lastName || '',
                email: contact.email,
                phone: contact.phone
            }));

            this.$handlers.customerHandler.sendMessage(
                this.customerId,
                {
                    title:this.title,
                    link: this.link,
                    emails,
                    whatsappNumbers,
                    message: this.message,
                    eventFieldValues,
                    //the meeting's links (אישור / שינוי / ביטול) are signed on the server
                    ...(meeting && meeting.id ? { meetingId: meeting.id } : {}),
                    contacts: contactsForTemplate,
                    ...(this.docName ? { docName: this.docName } : {}),
                    ...(this.signRequest ? { sign: true } : {}),
                    ...(this.ctaText ? { ctaText: this.ctaText } : {})
                }).then(() => {
                    //who it went to - the menu tab marks its approval link as sent
                    this.$emit('sent', { emails, whatsappNumbers });
                    this.$swal({
                        title: whatsappGoesToQueue ? 'ההודעה נשמרה' : 'ההודעה נשלחה בהצלחה',
                        text: whatsappGoesToQueue ? 'הודעות הואצאפ ממתינות בתור ויישלחו אחרי חיבור מחדש' : undefined,
                        icon: 'success',
                        confirmButtonColor: '#ab8ce4',
                    });
                    this.hide();
                });




        },
        show() {
            this.$refs.sendMessageToCustomerModal.show();
        },
        hide() {
            this.$refs.sendMessageToCustomerModal.hide();
        },

    },
    mounted() {
        // Your mounted hook code here
    },
    components: {
        MessageTemplatePopup
    }

};
</script>